import { ChangeDetectorRef, Component, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { IBreadcrumb } from '@app/lib/models/breadcrumb.model';
import { BreadcrumbComponent } from "@app/lib/components/breadcrumb/breadcrumb.component";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption } from "@angular/material/core";
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { JudgePanelAssignmentService } from '../services/judge-panel-assignment.service';
import { IResponse } from '@app/lib/models/response.model';
import { ICourtSessionPanel, IJudge, ISessionData } from '../models/case-assignment.model';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { NgFor } from '@angular/common';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatButtonModule } from '@angular/material/button';
import { CdkDrag, CdkDragDrop, CdkDropList, CdkDropListGroup, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatIcon } from "@angular/material/icon";
import { DialogService } from '@app/lib/services/dialog.service';
import { CaseNumberSearchComponent } from '../widget/case-number-search/case-number-search.component';
import { ILoginData } from '@app/lib/models/login.model';
import { ICaseHearingDetails } from '../models/justiceReassign.model';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';



@Component({
  selector: 'app-panel-re-assignment',
  standalone: true,
  imports: [BreadcrumbComponent,
    FormsModule,
    MatFormFieldModule,
    MatOption,
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatButtonModule,
    CdkDropListGroup,
    CdkDropList,
    CdkDrag,
    NgFor,
    MatIcon,
    CaseNumberSearchComponent],
  templateUrl: './panel-re-assignment.component.html',
  styleUrl: './panel-re-assignment.component.scss'
})
export class PanelReAssignmentComponent implements OnInit, OnDestroy {


  constructor(
    private dialog: MatDialog,
    private service: JudgePanelAssignmentService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
  ) {

  }
  sessions: ISessionData[] = [];
  panels: ICourtSessionPanel[] = [];
  public filteredSessions: ReplaySubject<ISessionData[]> = new ReplaySubject<ISessionData[]>(1);
  public sessionFilterCtrl: FormControl<string | null> = new FormControl<string | null>('');
  public filteredPanels: ReplaySubject<ICourtSessionPanel[]> = new ReplaySubject<ICourtSessionPanel[]>(1);
  public panelsFilterCtrl: FormControl<string | null> = new FormControl<string | null>('');
  protected _onDestroy = new Subject<void>();

  public breadcrumbs: WritableSignal<IBreadcrumb[]> = signal([
    { label: 'Court' },
    { label: 'Judge Panel Assignment' },
  ]);
  public searchFormGrp: FormGroup = new FormGroup({
    caseNumber: new FormControl('', { nonNullable: true, validators: [Validators.required] })
  });

  public justiceReassignmentForm: FormGroup = new FormGroup({
    appealNumber: new FormControl(''),
    hearingDate: new FormControl(''),
    panel: new FormControl('')
  });

  loading: boolean = false;
  isLoadingSession: boolean = false;
  isLoadingPanel: boolean = false;
  isSearching: boolean = false;
  isSearchComplete: boolean = false;

  // Modified Mock data for Judges Dual Listbox
  panelId: number = 0;
  panelName: string = '';
  casePhaseData: ICaseHearingDetails | null = null;
  availableJudges: IJudge[] = [];

  assignedJudges: IJudge[] = [];




  // State Tracking
  hasChanges: boolean = false;
  savedassignedJudges: IJudge[] = []; // To track "U" vs "I" records
  filteredAvailableJudges: IJudge[] = [];
  searchAvailableJudgesCtrl: FormControl = new FormControl('');

  userType: string = "";
  courtData: ILoginData | null = null;
  judgeLabel: string = 'Justice';
  selectedCaseItem: any = null;

  drop(event: CdkDragDrop<IJudge[]>) {
    // Prevent adding more than allowed judges to the panel judges list
    if (event.previousContainer !== event.container && event.container.id === 'panelList') {

    }

    if (event.previousContainer === event.container) {
      if (event.previousIndex !== event.currentIndex) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        this.hasChanges = true;
      }
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );

      // Keep availableJudges in sync if we drag from/to filteredAvailableJudges
      if (event.previousContainer.id === 'availableList') {
        const itemMoved = event.container.data[event.currentIndex];
        const moveId = itemMoved.justiceId ?? (itemMoved as any).judgeId ?? itemMoved.id;
        this.availableJudges = this.availableJudges.filter(j => (j.justiceId ?? (j as any).judgeId ?? j.id) !== moveId);
      } else if (event.container.id === 'availableList') {
        const itemMoved = event.container.data[event.currentIndex];
        const moveId = itemMoved.justiceId ?? (itemMoved as any).judgeId ?? itemMoved.id;
        if (!this.availableJudges.find(j => (j.justiceId ?? (j as any).judgeId ?? j.id) === moveId)) {
          this.availableJudges.push(itemMoved);
        }
      }

      this.hasChanges = true;
    }
  }

  ngOnInit() {
    this.courtData = this.getCourtNameData();
    this.userType = this.courtData?.courtId === 1 || this.courtData?.courtId === 2 ? 'admin' : 'lawyer';
    this.judgeLabel = this.courtData?.courtId === 1 || this.courtData?.courtId === 2 ? 'Justice' : 'Judge';

    this.searchAvailableJudgesCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string | null) => {
        this.filterAvailableJudges(search);
      });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }


  public onCaseSearchOptionSelected(item: any): void {
    this.selectedCaseItem = item || null;
    const caseNo = item?.caseNumber || item?.courtCaseNumber || '';
    if (caseNo) {
      this.searchFormGrp.patchValue({ caseNumber: caseNo });
    }
  }

  public searchHandler() {
    this.casePhaseData = null;
    this.availableJudges = [];
    this.filteredAvailableJudges = [];
    this.searchAvailableJudgesCtrl.setValue('');
    this.assignedJudges = [];
    this.savedassignedJudges = [];
    this.hasChanges = false;


    if (this.searchFormGrp.valid) {
      this.isSearching = true;
      const caseNumber = this.searchFormGrp.value.caseNumber || '';
      const reqBody = {
        "caseNumber": caseNumber
      };
      this.getCasePhases(reqBody);
      this.isSearchComplete = true;

    }
    else {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Please enter Case / Appeal Number',
          icon: 'info',
        }, disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
    }
  }

  getCourtNameData(): ILoginData | null {
    try {
      const userData = localStorage.getItem('userData') as string;
      return userData ? JSON.parse(userData) : null;
    } catch (err) {
      return null
    }

  }

  /**
   * Helper to safely extract an array from various backend response wrapper formats
   */
  private extractJudgesList(res: any): any[] {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    if (Array.isArray(res.data)) return res.data;
    if (Array.isArray(res.success)) return res.success;
    if (Array.isArray(res.result)) return res.result;
    if (Array.isArray(res.judges)) return res.judges;
    if (res.data && Array.isArray(res.data.judges)) return res.data.judges;
    if (res.data && Array.isArray(res.data.content)) return res.data.content;
    if (res.data && Array.isArray(res.data.data)) return res.data.data;
    return [];
  }

  /**
   * Helper to normalize judge object properties (justiceName/judgeName/name and justiceId/judgeId/id)
   */
  private normalizeJudge(judge: any): IJudge {
    const justiceId = judge.justiceId ?? judge.judgeId ?? judge.id ?? judge.justice_id ?? judge.judge_id;
    const justiceName = judge.justiceName ?? judge.judgeName ?? judge.name ?? judge.justice_name ?? judge.judge_name ?? judge.fullName ?? '';
    return {
      ...judge,
      justiceId: justiceId,
      justiceName: justiceName,
      id: judge.id ?? justiceId,
    };
  }

  /**
   * Helper to safely extract a single case phase object from various response formats
   */


  private getCasePhases(reqBody: any) {
    this.loading = true;
    this.service.getCasephases(reqBody).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res && res.data && res.data.courtCaseNumber != null) {
          this.casePhaseData = res.data


          const bodyAssigned = {
            panelId: this.casePhaseData?.panelId,
            caseId: this.casePhaseData?.caseId,
          };

          const bodyAvailable = {
            panelId: this.casePhaseData?.panelId,
            hearingDate: this.casePhaseData?.hearingDate,
            caseId: this.casePhaseData?.caseId
          };

          this.getAvailableJustices(bodyAvailable);
          this.getAssignedJustices(bodyAssigned);
          this.cdr.markForCheck();
        } else {
          this.dialogService.openDialog1({
            data: {
              title: "Warning",
              message: "No Data Exists",
              icon: 'warning',
            }, disableClose: true,
            hasBackdrop: true,
            backdropClass: 'dialog-backdrop',
          });
          return;
        }


      },
      error: (err) => {
        this.loading = false;
        console.error('Error fetching court data:', err);

        this.dialogService.openDialog1({
          data: {
            title: "Warning",
            message: err,
            icon: 'warning',
          }, disableClose: true,
          hasBackdrop: true,
          backdropClass: 'dialog-backdrop',
        });
        return;
        // Fallback to selectedCaseItem or search query so the section renders
      },
    });
  }

  private getAvailableJustices(reqBody: any) {
    this.service.getAvailableJusticesReassign(reqBody).subscribe({
      next: (res: any) => {
        const rawList = this.extractJudgesList(res);
        if (rawList && rawList.length > 0) {
          // Remove duplicates based on normalized justiceId + justiceName
          const uniqueJudgesMap = new Map<string, IJudge>();

          rawList.forEach(item => {
            const judge = this.normalizeJudge(item);
            const key = `${judge.justiceId}_${judge.justiceName}`;
            uniqueJudgesMap.set(key, judge);
          });

          this.availableJudges = Array.from(uniqueJudgesMap.values());
          this.filteredAvailableJudges = [...this.availableJudges];
          this.searchAvailableJudgesCtrl.setValue('', { emitEvent: false });

          console.log('Available Judges loaded successfully:', this.availableJudges);
        } else {
          this.availableJudges = [];
          this.filteredAvailableJudges = [];
          console.log('No available judges data found.', res);
        }
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error('Error fetching available judges:', err);
        this.cdr.markForCheck();
      },
    });
  }

  private getAssignedJustices(reqBody: any) {
    this.service.getAssignedJustices(reqBody).subscribe({
      next: (res: any) => {
        const rawList = this.extractJudgesList(res);
        if (rawList && rawList.length > 0) {
          // Remove duplicates based on normalized justiceId
          const uniqueJudgesMap = new Map<string, IJudge>();
          rawList.forEach(item => {
            const judge = this.normalizeJudge(item);
            const key = `${judge.justiceId}_${judge.justiceName}`;
            uniqueJudgesMap.set(key, judge);
          });

          this.assignedJudges = Array.from(uniqueJudgesMap.values());
          this.savedassignedJudges = this.assignedJudges.map(j => ({ ...j }));
          console.log('Panel Judges loaded successfully:', this.assignedJudges);
        } else {
          this.assignedJudges = [];
          this.savedassignedJudges = [];
          console.log('No panel judges data found.', res);
        }
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error('Error fetching assigned judges:', err);
        this.cdr.markForCheck();
      },
    });
  }



  resetHandler() {

    this.searchFormGrp.enable();
    this.searchFormGrp.reset();
    this.justiceReassignmentForm.reset();
    this.isSearchComplete = false;
    this.isSearching = false;
    this.casePhaseData = null;
    this.availableJudges = [];
    this.filteredAvailableJudges = [];
    this.searchAvailableJudgesCtrl.setValue('');
    this.assignedJudges = [];
    this.savedassignedJudges = [];
    this.hasChanges = false;
    this.panelId = 0;
    this.panelName = '';
  }


  saveAssignment() {
    if (this.assignedJudges.length === 0) {
      this.dialogService.openDialog1({
        data: {
          title: "Warning",
          message: 'A panel must have at least one justice remaining.',
          icon: 'warning',
        },
        disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
      return;
    }

    const cpData = (this.casePhaseData as any) || {};

    // Deduplicate assigned judges by justiceId
    const uniqueJudges = Array.from(
      new Map(
        this.assignedJudges.map(judge => [
          String(judge.justiceId ?? (judge as any).judgeId ?? judge.id),
          judge
        ])
      ).values()
    );

    const payload = {
      courtCaseNumber: cpData.courtCaseNumber || '',
      caseId: cpData.caseId != null ? String(cpData.caseId) : '',
      casePhId: cpData.casePhId != null ? String(cpData.casePhId) : '',
      caseStatusId: cpData.caseStatusId != null ? String(cpData.caseStatusId) : '',
      caseStatusName: cpData.caseStatusName || '',
      cptId: cpData.cptId != null ? String(cpData.cptId) : '',
      cptName: cpData.cptName || '',
      hearingDate: cpData.hearingDate || '',
      panelName: cpData.panelName || '',
      panelId: cpData.panelId != null ? String(cpData.panelId) : '',
      courtUnitId: cpData.courtUnitId != null ? String(cpData.courtUnitId) : '',
      docId: cpData.docId != null ? String(cpData.docId) : '',
      caseCategory: cpData.caseCategory !== undefined ? cpData.caseCategory : null,
      sessionId: cpData.sessionId != null
        ? Number(cpData.sessionId)
        : (this.searchFormGrp.value.sessionControl?.id ? Number(this.searchFormGrp.value.sessionControl.id) : 0),
      assignJudgeData: uniqueJudges.map(judge => ({
        id: judge.id != null ? Number(judge.id) : 0,
        panelName: (judge as any).panelName || '',
        panelId: (judge as any).panelId != null ? Number((judge as any).panelId) : 0,
        sessionId: (judge as any).sessionId != null ? Number((judge as any).sessionId) : 0,
        justiceId: String(judge.justiceId ?? (judge as any).judgeId ?? judge.id ?? ''),
        justiceName: String(judge.justiceName ?? (judge as any).judgeName ?? (judge as any).name ?? ''),
        beginDate: judge.beginDate ?? null,
        endDate: judge.endDate ?? null
      }))
    };

    // 1. Open confirmation dialog
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm Action',
        message: "Do you want to Assign?"
      },
      disableClose: true,           // Prevents closing on outside click or ESC 
      hasBackdrop: true,            // Shows backdrop to block interaction
      backdropClass: 'dialog-backdrop', // Optional: custom styling
    });


    // 2. Only proceed if user clicks confirm/yes
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) {
        return;
      }

      console.log('Save Payload:', payload);

      this.service.saveAssignedJudges(payload).subscribe({
        next: (res: any) => {
          if (res) {
            if (res.success) {
              const dialogRef = this.dialogService.openDialog1({
                data: {
                  title: "Success",
                  message: res.message || "Updated Successfully",
                  icon: 'check_small',
                },
                disableClose: true,
                hasBackdrop: true,
                backdropClass: 'dialog-backdrop',
              });
              dialogRef.afterClosed().subscribe(() => {
                this.searchFormGrp.patchValue({ caseNumber: payload.courtCaseNumber });
                this.searchHandler();
              });
            } else {
              this.dialogService.openDialog1({
                data: {
                  title: "Information",
                  message: res.message || res.data?.validString || "An error occurred",
                  icon: 'info',
                },
                disableClose: true,
                hasBackdrop: true,
                backdropClass: 'dialog-backdrop',
              });
            }
          }
        },
        error: (err: any) => {
          this.dialogService.openDialog1({
            data: {
              title: "Error",
              message: "Failed to save data. Please try again.",
              icon: 'error',
            },
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'dialog-backdrop',
          });
          console.error('Error saving data:', err);
        }
      });
    });
  }

  protected filterSession() {
    if (!this.sessions) return;

    let search = this.sessionFilterCtrl.value;
    if (!search) {
      this.filteredSessions.next(this.sessions.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // Filter based on partyName
    this.filteredSessions.next(
      this.sessions.filter(session => session.name.toLowerCase().indexOf(search) > -1)
    );
  }
  protected filterPanels() {
    if (!this.panels) return;

    let search = this.panelsFilterCtrl.value;
    if (!search) {
      this.filteredPanels.next(this.panels.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // Filter based on partyName
    this.filteredPanels.next(
      this.panels.filter(panel => panel.name.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterAvailableJudges(search: string | null) {
    if (!this.availableJudges) {
      this.filteredAvailableJudges = [];
      return;
    }
    if (!search || !search.trim()) {
      this.filteredAvailableJudges = [...this.availableJudges];
      return;
    }
    const lowerSearch = search.trim().toLowerCase();
    this.filteredAvailableJudges = this.availableJudges.filter(judge => {
      const name = (judge.justiceName || (judge as any).judgeName || (judge as any).name || '').toLowerCase();
      const id = String(judge.justiceId ?? (judge as any).judgeId ?? judge.id ?? '');
      return name.includes(lowerSearch) || id.includes(lowerSearch);
    });
  }

}
